import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatRow, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { GetStreamRecurringLoadsResponse, RecurringLoadData, StreamRecurringLoad } from '../../../../interfaces/streamrecurringLoad';
import { FeedstockService } from '../../../../services/feedstockservice';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatMenu, MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { ConfirmationDialogComponent, ConfirmationDialogData } from '../../../shared/components/confirmation-dialog/confirmation-dialog.component';
import { AddeditRecurringloadsComponent } from '../addedit-recurringloads/addedit-recurringloads.component';
import { RolePermissionsService } from '../../../../services/role-permissions.service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RoleService } from '../../../../services/role.service';
import { LoadScheduleControlFlags, ScreenName } from '../../../../interfaces/securityPermissions';

@Component({
  selector: 'app-recurring-loads',
  imports: [
    MatTableModule,
    MatButtonModule,
    MatIconModule,
    MatCardModule,
    CommonModule,
    FormsModule,
    MatIcon,
    MatRow,
    MatPaginatorModule,
    MatSortModule,
    MatMenuModule,
    MatDialogModule,
    DragDropModule
],
  templateUrl: './recurring-loads.component.html',
  styleUrl: './recurring-loads.component.scss'
})
export class RecurringLoadsComponent implements OnInit {
  permissions = inject(RolePermissionsService);
  private dialogRef = inject(MatDialogRef<RecurringLoadsComponent>);
  public data: RecurringLoadData = inject(MAT_DIALOG_DATA);
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  streamId: number = 0;
  genid = 0
  canAdd: boolean = true; 
  canEditDelete: boolean = true; 

  displayedColumns: string[] = [];
  dataSource = new MatTableDataSource<GetStreamRecurringLoadsResponse>([]);
  recurrLoads: GetStreamRecurringLoadsResponse[] = [];
  controlPermissions: LoadScheduleControlFlags = new LoadScheduleControlFlags();

  constructor(private fsService: FeedstockService,private _dialog: MatDialog, private rolesService: RoleService){
  }

  ngOnInit(): void {
    this.streamId = this.data.streamid;
    this.genid = this.data.genid;
    console.log('Recurring Loads opened for Stream ID:', this.streamId);
    
    this.displayedColumns = [
      'actions',
      'weekDays', 
      'disposalSiteNames', 
      'tankName',
      'recur_typeName', 
      'daySequenceName', 
      'noOfRecurrings'
    ];
    
    let roles = this.rolesService.getRolesAsString();
    this.permissions.getRolePermissionsNew(roles, ScreenName.Recurring, 0).subscribe({
      next: (perms: LoadScheduleControlFlags) => {
        this.controlPermissions = perms;
      }
    })
    
    this.loadRecurringLoads(this.streamId);
  }

  loadRecurringLoads(id: number): void {    
    this.fsService.getStreamRecurringLoads(this.streamId, this.genid).subscribe({
      next: (res: GetStreamRecurringLoadsResponse[]) => {
        console.log("recurr res", res);
        this.recurrLoads = res;
        this.dataSource = new MatTableDataSource(this.recurrLoads);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      }
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }
  
  onAddRecurLoad(): void {
    const dialogRef = this._dialog.open(AddeditRecurringloadsComponent, {
      data: {
        loadToEdit: null,
        streamId: this.streamId,
        genId: this.genid,
        canSave: true
      },
      width: '650px',
      disableClose: true,
      maxHeight: '90vh'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadRecurringLoads(this.streamId);
      }
    });
  }
  
  onEditRecurLoad(load: GetStreamRecurringLoadsResponse, task: string): void {
    const dialogRef = this._dialog.open(AddeditRecurringloadsComponent, {
      data: {
        loadToEdit: load,
        streamId: this.streamId,
        genId: this.genid,
        canSave: this.controlPermissions.edit
      },
      width: '650px',
      maxHeight: '90vh',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.loadRecurringLoads(this.streamId);
      }
    });
  }

  onDeleteRecurLoad(id: number, name: string): void {    
    const dialogData: ConfirmationDialogData = {
      title: 'Confirm Deletion',
      message: `Are you sure you want to delete Recurring Type: ${name}?`,
      confirmButtonText: 'Delete',
      cancelButtonText: 'Cancel',
      confirmButtonColor: 'warn'
    };

    this._dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      panelClass: 'delete-confirmation-dialog',
      data: dialogData,
      disableClose: true
    }).afterClosed().subscribe(result => {
      if (result) {
        if (id !== null && id !== undefined) {          
          this.fsService.deleteRecurrLoad(id).subscribe({
            next: () => {
              this.dataSource.data = this.dataSource.data.filter(item => item.id !== id);
            }
          });
        }
      }
    });
  }
}
